import React, { useCallback, useEffect, useLayoutEffect, useReducer, useState } from "react";

import {
  Box, Grid, IconButton, TextField, Button, Dialog, Chip, DialogActions,
  DialogContent, DialogTitle, Divider, Tooltip, Badge, Popover
} from "@mui/material";

import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import LoadingButton from '@mui/lab/LoadingButton';
import { FileDrop } from 'react-file-drop';
import CloseIcon from '@mui/icons-material/Close';
import ImportIcon from '@mui/icons-material/Upload';
import ReactHtmlParser from 'react-html-parser';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SmsIcon from '@mui/icons-material/Sms';

import './styles.css'
import VariableTextField from "../../../../Input/VariableTextField";
import { lockedReducer } from "../../../../../utils/defaultReducer";
import GestureIcon from '@mui/icons-material/Gesture';
import { SignatureAppendix } from "../../../../Crm/TabButtons/SendMessage/SendEmail";
import api from "../../../../../api";
import { getSession } from "../../../../../auth";
import DraggableBox from "../../../../../utils/draggableBox";
import { normalizeEmailRecipients, validateEmailRecipients } from "../../../../../utils/emailRecipients";

const retrieveEmailConfiguration = async (chatInfo, setExtra) => {
  // Retrieve emailbox config and subject
  const enterpriseId = getSession().profile.enterprise.id
  const res = await api.post(`/api/enterprises/${enterpriseId}/email/chatmailconf/`, {
    sender: chatInfo.sender,
    uniqueid: chatInfo.uniqueid,
    notification: chatInfo.notification
  }, { timeout: 15000 })
  if (res.status === 200) {
    setExtra(res.data)
  }
}

const EmailFooter = ({
  sendMessage,
  asBuiltIn = false,
  chatInfo = null,
  setLoading = () => { },
  showPredefinedMessages = null,
  usePredefinedMessageEmail = null,
  opportunityCustomFields = null,
  readOnly = false,
}) => {

  const [bodyTextContent, setBodyTextContent] = useState('');
  const [showAttachments, setShowAttachments] = useState(false)
  const [attachments, setAttachments] = useState([])
  const [showHTML, setShowHTML] = useState(false)

  const [extra, setExtra] = useReducer(lockedReducer, {
    subject: '',
    cc: '',
    cco: '',
    sendSignature: true,
    showCC: false,
    anchorEl: null,
    config: null,
    email: 0
  })

  useEffect(() => {
    chatInfo ? retrieveEmailConfiguration(chatInfo, setExtra) : null
    window.setEmailData = (initData) => {
      setAttachments(initData.attachments || [])
      setBodyTextContent(initData.bodyTextContent || '')
    }
    window.setEmailPredefinedMessage = (text) => {
      setBodyTextContent(prev => prev ? `${prev}${text}` : text);
    }
    window.setCleanEmailPredefinedMessage = (text) => {
      setBodyTextContent(text || '');
    }
    return () => {
      window.setEmailData = () => { }
      window.setEmailPredefinedMessage = null
      window.setCleanEmailPredefinedMessage = null
    }
  }, [])


  const setFormattingOnBody = (formattingCharacter) => {
    if (!bodyTextContent)
      return;

    const selectedText = window.getSelection().toString();
    const caretIndexStart = document.getElementById('body-textarea').selectionStart;
    const caretIndexEnd = document.getElementById('body-textarea').selectionEnd;

    if (selectedText) {
      setBodyTextContent(bodyTextContent.substring(0, caretIndexStart) + `${formattingCharacter}${selectedText}${formattingCharacter.replace('<', '</')}` + bodyTextContent.substring(caretIndexEnd, bodyTextContent.length));
    } else {
      setBodyTextContent(bodyTextContent.substring(0, caretIndexStart) + `${formattingCharacter}${formattingCharacter.replace('<', '</')}` + bodyTextContent.substring(caretIndexStart, bodyTextContent.length));
    }
  }

  const validatedCc = validateEmailRecipients(extra.cc)
  const validatedCco = validateEmailRecipients(extra.cco)

  const sendEmailMessage = async () => {
    setLoading(true)
    const res = await sendMessage(bodyTextContent, true, attachments, {
      ...extra,
      cc: normalizeEmailRecipients(extra.cc),
      cco: normalizeEmailRecipients(extra.cco)
    })
    setLoading(false)
    if (res !== -1) {
      setBodyTextContent('')
      setAttachments([])
    }
  }

  if (asBuiltIn)
    asBuiltIn({
      bodyTextContent: bodyTextContent,
      attachments: attachments
    })

  return (
    <Box class={`email-input ${asBuiltIn ? 'white' : ''}`}>
      {showAttachments &&
        <Dialog
          open='true'
          disablePortal
          fullWidth
          maxWidth='md'
          disableEnforceFocus
          sx={{ position: 'absolute' }}>
          <DialogTitle id="customized-dialog-title" className={'group-flexbox'}>
            <span>Adicionar anexos</span> <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={() => { setShowAttachments(false) }} ><CloseIcon /></Button>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <div className="file-drop-container">
              <FileDrop
                onDrop={(files, event) => { setAttachments([...attachments, ...files]); event.target.value = null }}
              >
                {attachments.length > 0 ? attachments.map(attachment =>
                  <Chip label={attachment.name || attachment.filename} onDelete={() => { setAttachments(attachments.filter(each => each !== attachment)) }} />) :
                  <span>Arraste e solte para inserir anexos.
                  </span>
                }
                <span>ou</span>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  component="label"
                  loading={false}
                  loadingPosition="start"
                  startIcon={<ImportIcon />}
                  disabled={false}
                  onClick={() => { }}
                >
                  Selecione
                  <input
                    hidden
                    multiple='true'
                    accept={'any'}
                    type="file"
                    onChange={(e) => { setAttachments([...attachments, ...e.target.files]); e.target.value = null }}
                  />
                </LoadingButton>
              </FileDrop>
            </div>
          </DialogContent>
          <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
            <LoadingButton
              onClick={() => { setAttachments([]) }}
              color="primary"

            >
              Limpar todos
            </LoadingButton>
            <LoadingButton
              onClick={() => { setShowAttachments(false) }}
              color="primary"

            >
              Confirmar
            </LoadingButton>
          </DialogActions>
        </Dialog>
      }
      <Grid container item spacing={0.5} class="email-input-container">
        <Grid item lg={12} md={12} sm={12} xs={12} class="email-input-actions">
          <IconButton onClick={() => setFormattingOnBody('<strong>')} size="small">
            <FormatBoldIcon color="primary" />
          </IconButton>
          <IconButton onClick={() => setFormattingOnBody('<em>')} size="small">
            <FormatItalicIcon color="primary" />
          </IconButton>
          <IconButton onClick={() => setFormattingOnBody('<s>')} size="small">
            <StrikethroughSIcon color="primary" />
          </IconButton>
          <Tooltip title={attachments.map(each => each.name || each.filename).join(', ')}>
            <Badge badgeContent={attachments.length} className='lower-badge' color="success" >
              <IconButton onClick={() => setShowAttachments(true)} size="small" badge>
                <AttachEmailIcon color="primary" />
              </IconButton>
            </Badge>
          </Tooltip>
          <Tooltip title={'Visualizador HTML'}>
            <IconButton  color="primary" onClick={()=>setShowHTML(true)}><VisibilityIcon/></IconButton>
          </Tooltip>
          {showPredefinedMessages && 
            <Tooltip title="Mensagens predefinidas">
              <IconButton onClick={showPredefinedMessages} size="small">
                <SmsIcon color="primary" />
              </IconButton>
            </Tooltip>
          }
          <DraggableBox 
              show={showHTML} 
              handleClose={()=>setShowHTML(false)} 
              x={0}
              y={0} 
              className='draggable-box-email'
              title='Visualização do E-mail'
            >
                {ReactHtmlParser(bodyTextContent)}
          </DraggableBox>
          <Box>
            {!asBuiltIn && <SignatureAppendix parent={extra} setParent={setExtra} setLoading={setLoading} />}
          </Box>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} class="email-input-content">
          {asBuiltIn ?
            <>
              <VariableTextField
                id="body-textarea"
                multiline
                rows={10}
                size="small"
                label="Corpo"
                fullWidth
                type="text"
                variant="outlined"
                inputProps={{ maxLength: 40000 }}
                value={bodyTextContent}
                onChange={(event) => setBodyTextContent(event.target.value)}
                onVariableSelect={(value) => setBodyTextContent(`${bodyTextContent} ${value}`)}
                opportunityCustomFields={opportunityCustomFields}
                disabled={readOnly}
              />
              <Box className={'templates-footer flexedGap'}>
                <Box className="character-counter positionUnset" >
                  {`${bodyTextContent?.length || 0} / ${40000} caracteres`}
                </Box>
              </Box>
            </>
            :
            <>
              <TextField
                fullWidth
                sx={{ '& .MuiOutlinedInput-root': { paddingRight: 0 } }}
                size='small'
                label="Assunto"
                disabled={chatInfo.where !== 'finished'}
                value={extra.subject}
                onChange={({ target }) => setExtra({ subject: target.value })}
                InputProps={{
                  endAdornment: <Button onClick={({ currentTarget }) => setExtra({ showCC: true, anchorEl: currentTarget })} sx={{ width: '6rem' }}><span style={{ height: '1.3rem' }}>CC e CCO</span></Button>
                }}
              />
              <Popover
                className="popover-filter"
                open={extra.showCC}
                anchorEl={extra.anchorEl}
                onClose={() => { setExtra({ showCC: false, anchorEl: null }) }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Box sx={{display: 'flex', gap: '1rem', flexDirection: 'column'}}>
                  <TextField
                    label='Cópia'
                    sx={{ width: '100%' }}
                    value={extra.cc}
                    onChange={({ target }) => setExtra({ cc: target.value })}
                    size='small'
                    error={!validatedCc}
                    helperText={extra.cc && !validatedCc && "Por favor, insira e-mail(s) válido(s)"}
                    inputProps={{
                      maxLength: 5000
                    }}
                  />
                  <TextField
                    label='Cópia Oculta'
                    sx={{ width: '100%' }}
                    value={extra.cco}
                    onChange={({ target }) => setExtra({ cco: target.value })}
                    size='small'
                    error={!validatedCco}
                    helperText={extra.cco && !validatedCco && "Por favor, insira e-mail(s) válido(s)"}
                    inputProps={{
                      maxLength: 5000
                    }}
                  />
                </Box>
              </Popover>
              <TextField
                id="body-textarea"
                multiline
                rows={10}
                size="small"
                sx={{ background: 'white' }}
                label="Corpo"
                fullWidth
                type="text"
                variant="outlined"
                inputProps={{ maxLength: 40000 }}
                value={bodyTextContent}
                onChange={(event) => setBodyTextContent(event.target.value)}
              />
            </>
          }

        </Grid>
        {!asBuiltIn &&
          <Grid item lg={12} md={12} sm={12} xs={12} class="email-input-buttons">
            <Button disabled={!validatedCc || !validatedCco} onClick={sendEmailMessage}>Enviar</Button>
          </Grid>
        }
      </Grid>
    </Box>
  )
}

export default EmailFooter;
